import React from "react";
import { useHistory } from "react-router-dom";
import CitySelect from "./CitySelect";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import { Theme, makeStyles, createStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";

export default function Navbar({ page = "" }) {
  const classes = useStyles();
  const history = useHistory();

  return (
    <AppBar position="static">
      <Toolbar>
        <Typography
          variant="h6"
          className={classes.title}
          onClick={()=>history.push("/")}
        >
          Призвание
        </Typography>
        <Button
          color={page === "results" ? "secondary" : "inherit"}
          className={page === "results" ? classes.active : classes.inactive}
          onClick={()=>history.push("/results")}
        >
          Занятия
        </Button>
        <Tooltip title="Этот раздел пока недоступен">
          <span>
            <Button
              color={page === "events" ? "secondary" : "inherit"}
              className={page === "events" ? classes.active : classes.inactive}
              disabled
            >
              Мероприятия
            </Button>
          </span>
        </Tooltip>
        <Button
          color={page === "howto" ? "secondary" : "inherit"}
          className={page === "howto" ? classes.active : classes.inactive}
          onClick={()=>history.push("/")}
        >
          Как использовать
        </Button>
        <CitySelect/>
      </Toolbar>
    </AppBar>
  )
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    title: {
      flexGrow: 1,
      cursor: "pointer",
    },
    active: {
      fontWeight: theme.typography.fontWeightMedium,
    },
    inactive: {

    },
  })
);